export default __webpack_public_path__ + "static/media/craon21.7944b539.jpg";